var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _path4, _path5, _path6, _rect6, _rect7, _rect8, _rect9, _polygon, _polygon2, _polygon3, _rect10, _rect11, _rect12, _path7, _path8, _path9, _path10, _path11, _g, _g2, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodingMonochromaticFebff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 509.23 364.6",
    "data-imageid": "coding-monochromatic-febff",
    imageName: "Coding",
    className: "illustrations_image",
    style: {
      width: 237
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 225,
    y1: 279.58,
    x2: 246.68,
    y2: 279.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ead4d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e9cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 196.9,
    y1: 214.27,
    x2: 270.4,
    y2: 214.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 235.47,
    y1: 403.52,
    x2: 245.47,
    y2: 302.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 236.71,
    y1: 341.09,
    x2: 236.71,
    y2: 400.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 224.9,
    y1: 346.73,
    x2: 252.31,
    y2: 206.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 210.88,
    y1: 311.27,
    x2: 250.61,
    y2: 311.27,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 223.84,
    y1: 324.62,
    x2: 258.66,
    y2: 324.62,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 170.56,
    y1: 395.25,
    x2: 224.36,
    y2: 395.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 259.78,
    y1: 395.21,
    x2: 306.81,
    y2: 395.21,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Code 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M50.28,259.38c5.86-11.1,15.44-21.13,15.81-33.68.26-9.18-4.56-17.6-8.09-26.09-18-43.23.64-98.39,41.13-121.9,22.1-12.83,48.29-16.49,73.8-17.93a500.35,500.35,0,0,1,86.79,2.63c16.88,2,34.55,5.23,47.61,16.1,20.47,17,23.36,46.63,31.14,72.09,13.67,44.72,47.42,82.87,90.13,101.9,7.73,3.44,15.92,6.4,22.17,12.1,13.71,12.48,13.85,34.94,5.4,51.44S432.65,344.47,418,355.87l-45.46,35.45c-9.2,7.17-18.62,14.47-29.65,18.26-36.75,12.64-86.6-2.22-124.75-3.91-24.63-1.1-50.74,1.34-74.81-5.08C90.05,386.36,19,318.71,50.28,259.38Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.83,
    y: 187.67,
    width: 136.11,
    height: 83.47,
    rx: 10.6,
    transform: "translate(677.21 408.78) rotate(-180)",
    fill: "#68e1fd",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.79,
    y: 227.5,
    width: 105.11,
    height: 65.32,
    rx: 8.24,
    transform: "translate(246.12 470.28) rotate(-180)",
    fill: "#68e1fd",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.37,215.61h-160a26.46,26.46,0,0,1-26.43-26.42V76.57a26.46,26.46,0,0,1,26.43-26.43h160a26.46,26.46,0,0,1,26.42,26.43V189.19A26.45,26.45,0,0,1,485.37,215.61Zm-160-161.52a22.5,22.5,0,0,0-22.48,22.48V189.19a22.5,22.5,0,0,0,22.48,22.47h160a22.5,22.5,0,0,0,22.47-22.47V76.57a22.5,22.5,0,0,0-22.47-22.48Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    opacity: 0.63,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.61,123.46h-64.9a11.9,11.9,0,0,1-11.89-11.89V65.9A11.9,11.9,0,0,1,137.71,54h64.9A11.9,11.9,0,0,1,214.5,65.9v45.67A11.9,11.9,0,0,1,202.61,123.46ZM137.71,58a8,8,0,0,0-7.94,7.94v45.67a8,8,0,0,0,7.94,7.94h64.9a8,8,0,0,0,7.94-7.94V65.9A8,8,0,0,0,202.61,58Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    opacity: 0.63,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.82,292.41a6.15,6.15,0,0,0,1,3.21,4.57,4.57,0,0,0,2.14,1.39c3.82,1.35,8-.21,11.75-1.76a10.11,10.11,0,0,0,4.36-2.77,9.44,9.44,0,0,0,1.47-5.29,79.24,79.24,0,0,0-.93-18.07,9.62,9.62,0,0,0-1.53-4.39c-1.85-2.45-5.33-2.78-8.4-2.9-7.73-.29-10-1.28-10.44,6.82A147.34,147.34,0,0,0,225.82,292.41Z",
    transform: "translate(-2.56 -50.04)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.56,234.62a41,41,0,0,0,7.62,11.63,32.35,32.35,0,0,0,49.6-3.51c4.8-6.69,6.86-14.94,8.3-23.05,1.25-7.1,2.1-14.49.25-21.46-2.43-9.11-9.4-16.62-17.8-20.88s-18.1-5.5-27.5-4.83c-5.88.43-11.82,1.62-16.93,4.54C197,182.8,196.54,190.76,197,201.14,197.55,212.52,198.83,224.13,203.56,234.62Z",
    transform: "translate(-2.56 -50.04)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.46,147.12c-2.78-3-6.07-6.06-10.17-6.55s-8.78,2.9-8,7c-6.35-3.05-13.79-5.56-20.29-2.85-5.46,2.26-9,8-9.76,13.82s1,11.82,3.76,17a28.37,28.37,0,0,0,6.13,8.1c5.86,5.16,14,6.6,21.78,7.51,13.2,1.54,26.84,2.1,39.49-2,3.82-1.23,8.59-2.67,11.37.23,2.07,2.15,2.69,6.41,5.68,6.4,2.42,0,3.52-3,3.75-5.43a44.83,44.83,0,0,0-1.72-17.12c-2.91-9.63-9.84-17-20.39-16.92C237.32,156.43,232.21,154.5,225.46,147.12Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#e08142"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 199.58,
    y: 149.95,
    width: 25.75,
    height: 17.78,
    rx: 7.23,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3.95
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 234.6,
    y: 149.95,
    width: 25.75,
    height: 17.78,
    rx: 7.23,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3.95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 223.07,
    y: 156.99,
    width: 14.35,
    height: 2.13,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 189.58,
    y: 154.77,
    width: 11.67,
    height: 3.33,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 258.85,
    y: 156.07,
    width: 12.97,
    height: 2.22,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.63,235.78a40.73,40.73,0,0,0,.66,9.62c1.62,7,7,12.79,13.38,16.08a51.41,51.41,0,0,1,5.55,2.92c1.82,1.25,3.33,2.93,5.16,4.18a14.17,14.17,0,0,0,14.94.45c1.39-.83,2.77-1.95,4.39-1.87,1.24,0,2.32.81,3.49,1.21,2.67.91,5.59-.08,8.15-1.27s4.93-2.61,6-5.05c.71-1.58.74-3.37,1.08-5.07.86-4.36,3.67-8.06,5.4-12.16,3.6-8.49,2.4-18.16,1.14-27.29l-4.16,6.89c-1.4,2.32-3,4.79-5.54,5.71-3.35,1.19-6.91-.75-10.15-2.24a42.21,42.21,0,0,0-32.68-.85c-2.16.86-4.45,1.92-6.72,1.38-2.7-.64-6.65-7.74-8.78-7.12C198.34,222.08,199.65,233.6,199.63,235.78Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#e08142"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.86,283.26c27.08-3.86,55.85,9.87,69.89,33.35,4.68,7.84,7.82,16.57,13,24.1,5.47,8,13,14.29,19.29,21.63a87.06,87.06,0,0,1,12.65,19.59c3,6.44,5.13,14.48,1.1,20.35-3.7,5.4-11,6.7-17.55,7.19-13,1-26.11.67-39.17.34l-128.32-3.17c-5.72-.14-11.58-.31-16.89-2.44s-10-6.69-10.68-12.37c-1-8.32,6.45-14.84,12-21.13,16.13-18.36,19.74-45.07,35.28-63.93A63.48,63.48,0,0,1,224,284",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.86,283.26c27.08-3.86,55.85,9.87,69.89,33.35,4.68,7.84,7.82,16.57,13,24.1,5.47,8,13,14.29,19.29,21.63a87.06,87.06,0,0,1,12.65,19.59c3,6.44,5.13,14.48,1.1,20.35-3.7,5.4-11,6.7-17.55,7.19-13,1-26.11.67-39.17.34l-128.32-3.17c-5.72-.14-11.58-.31-16.89-2.44s-10-6.69-10.68-12.37c-1-8.32,6.45-14.84,12-21.13,16.13-18.36,19.74-45.07,35.28-63.93A63.48,63.48,0,0,1,224,284",
    transform: "translate(-2.56 -50.04)",
    fill: "url(#linear-gradient-3)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 178.65,
    y: 350.18,
    width: 116.13,
    height: 7.78,
    fill: "#68e1fd",
    className: "target-color"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 178.65,
    y: 350.18,
    width: 116.13,
    height: 7.78,
    fill: "url(#linear-gradient-4)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 146.6,
    y: 221.64,
    width: 182.66,
    height: 110.39,
    rx: 20.61,
    fill: "#68e1fd",
    className: "target-color"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 146.6,
    y: 224.97,
    width: 182.66,
    height: 110.39,
    rx: 20.61,
    fill: "url(#linear-gradient-5)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "210.88 330.71 230.32 291.28 248.11 291.28 250.61 331.27 210.88 330.71",
    opacity: 0.26,
    fill: "url(#linear-gradient-6)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "257 357.96 222.17 357.96 230.32 291.28 248.11 291.28 257 357.96",
    fill: "#68e1fd",
    className: "target-color"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "258.66 357.96 223.84 357.96 231.99 291.28 249.77 291.28 258.66 357.96",
    fill: "url(#linear-gradient-7)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 298.33,
    width: 208.93,
    height: 161.51,
    rx: 24.45,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.25,250.29H20.79A18.26,18.26,0,0,1,2.56,232.05V157.14A18.26,18.26,0,0,1,20.79,138.9H127.25a18.26,18.26,0,0,1,18.23,18.24v74.91A18.26,18.26,0,0,1,127.25,250.29ZM20.79,142.85A14.31,14.31,0,0,0,6.5,157.14v74.91a14.31,14.31,0,0,0,14.29,14.29H127.25a14.31,14.31,0,0,0,14.29-14.29V157.14a14.31,14.31,0,0,0-14.29-14.29Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    opacity: 0.63,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1.97,
    y: 88.16,
    width: 138.98,
    height: 107.44,
    rx: 16.26,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 124.96,
    y: 4.14,
    width: 84.73,
    height: 65.5,
    rx: 9.91,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.32,87.62l21.38-11V79.8l-18,9v.1l18,9v3.19l-21.38-11Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.68,103l12.86-33.42h3.13L165.77,103Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202.94,90.24l-21.36,11V98l18.15-9v-.15l-18.15-9V76.61l21.36,11Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M212.62,385.73c-4.58-.92-9.3-.08-14,.06-4.48.13-9-.4-13.43,0s-9.07,2-11.93,5.41a11.85,11.85,0,0,0-2.72,7.93,6.21,6.21,0,0,0,.8,3.08c1.22,1.95,3.76,2.54,6,2.87a4.06,4.06,0,0,0,1.39,0c1.65-.36,2.23-2.48,3.66-3.36a5.64,5.64,0,0,1,3.13-.54q17.58.36,35.17-.14a4.63,4.63,0,0,0,2.33-.48c3.2-2-.5-6.48-1.65-8.62A12.66,12.66,0,0,0,212.62,385.73Z",
    transform: "translate(-2.56 -50.04)",
    fill: "url(#linear-gradient-8)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M261.4,391.74c-1.61,2.21-2.49,5.72-.32,7.38,1.95,1.5,4.81.26,6.63-1.39s3.48-3.79,5.9-4.26c.36,2.1.84,4.4,2.56,5.65,2.61,1.9,6.21.26,9.43.29,2.9,0,6.21,1.37,8.45-.48,1.16-1,2.48-2.77,3.68-1.85a2.39,2.39,0,0,1,.69,1.23,34.38,34.38,0,0,0,4.8,9.45c1.46.57,2.56-1.41,2.84-3a47.44,47.44,0,0,0,.51-13.14c-.24-2.44-.76-5-2.5-6.76-2.27-2.27-5.86-2.37-9.07-2.32l-12.88.19C274.46,382.88,266.17,385.22,261.4,391.74Z",
    transform: "translate(-2.56 -50.04)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.55,311.57a12.77,12.77,0,1,1-12.79-12.79,8.57,8.57,0,0,1,2,.2,12.61,12.61,0,0,0,10.74,12.12A1.83,1.83,0,0,1,254.55,311.57Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    opacity: 0.59,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.96,
    y: 21.4,
    width: 53.4,
    height: 3.92,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.96,
    y: 28.98,
    width: 32.59,
    height: 3.68,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 28.98,
    width: 102.56,
    height: 3.7,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.91,
    y: 36.57,
    width: 44.82,
    height: 3.88,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.3,
    y: 44.15,
    width: 53.4,
    height: 3.92,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.18,
    y: 44.15,
    width: 44.76,
    height: 4.35,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.22,
    y: 51.73,
    width: 41.23,
    height: 3.68,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.41,
    y: 51.73,
    width: 85.08,
    height: 4.07,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.96,
    y: 61.98,
    width: 53.4,
    height: 3.92,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.96,
    y: 69.56,
    width: 32.59,
    height: 3.68,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 69.56,
    width: 102.56,
    height: 3.7,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.91,
    y: 77.14,
    width: 44.82,
    height: 3.88,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.3,
    y: 84.73,
    width: 53.4,
    height: 3.92,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.18,
    y: 84.73,
    width: 44.76,
    height: 4.35,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.22,
    y: 92.31,
    width: 41.23,
    height: 3.68,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.41,
    y: 92.31,
    width: 85.08,
    height: 4.07,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.96,
    y: 102.57,
    width: 53.4,
    height: 3.92,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.96,
    y: 110.14,
    width: 32.59,
    height: 3.68,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 110.14,
    width: 102.56,
    height: 3.7,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.91,
    y: 117.72,
    width: 44.82,
    height: 3.88,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.3,
    y: 125.3,
    width: 53.4,
    height: 3.92,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.18,
    y: 125.3,
    width: 44.76,
    height: 4.35,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.22,
    y: 132.9,
    width: 41.23,
    height: 3.68,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.41,
    y: 132.9,
    width: 85.08,
    height: 4.07,
    fill: "#68e1fd",
    className: "target-color"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 104.93,
    width: 34.69,
    height: 2.54,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 109.85,
    width: 21.18,
    height: 2.39,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.23,
    y: 109.85,
    width: 66.63,
    height: 2.4,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.52,
    y: 114.79,
    width: 29.12,
    height: 2.52,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.87,
    y: 119.71,
    width: 34.69,
    height: 2.54,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.82,
    y: 119.71,
    width: 29.08,
    height: 2.83,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.82,
    y: 124.64,
    width: 26.79,
    height: 2.39,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.17,
    y: 124.64,
    width: 55.28,
    height: 2.65,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 131.3,
    width: 34.69,
    height: 2.54,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 136.22,
    width: 21.18,
    height: 2.39,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.23,
    y: 136.22,
    width: 66.63,
    height: 2.4,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.52,
    y: 141.15,
    width: 29.12,
    height: 2.52,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.87,
    y: 146.08,
    width: 34.69,
    height: 2.54,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.82,
    y: 146.08,
    width: 29.08,
    height: 2.83,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.82,
    y: 151,
    width: 26.79,
    height: 2.39,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.17,
    y: 151,
    width: 55.28,
    height: 2.65,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 157.67,
    width: 34.69,
    height: 2.54,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 162.59,
    width: 21.18,
    height: 2.39,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.23,
    y: 162.59,
    width: 66.63,
    height: 2.4,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.52,
    y: 167.51,
    width: 29.12,
    height: 2.52,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.87,
    y: 172.44,
    width: 34.69,
    height: 2.54,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.82,
    y: 172.44,
    width: 29.08,
    height: 2.83,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.82,
    y: 177.37,
    width: 26.79,
    height: 2.39,
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.17,
    y: 177.37,
    width: 55.28,
    height: 2.65,
    fill: "#68e1fd",
    className: "target-color"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "P2hkdg",
    opacity: 0.61,
    style: {
      isolation: "isolate"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M340.61,300.71c.32-1.71.66-3.42,1-5.13.18-1,.35-1.93.54-3,1.6.27,3.16.52,4.71.82a.8.8,0,0,0,1.05-.52c.7-1.36,1.48-2.68,2.3-4a.77.77,0,0,0-.07-1.12c-1-1.19-2-2.42-3.11-3.69l6.7-5.63c1,1.23,2.06,2.42,3.05,3.65a.84.84,0,0,0,1.22.28,33.56,33.56,0,0,1,4.14-1.51c.65-.19.8-.45.79-1.06,0-1.53,0-3.06,0-4.65h8.74c0,1.57,0,3.12,0,4.67,0,.62.16.85.79,1a35.33,35.33,0,0,1,4.14,1.52.83.83,0,0,0,1.21-.3c1-1.21,2-2.39,3.05-3.64l6.69,5.62-3.43,4.11c.93,1.71,1.8,3.35,2.73,4.95.1.18.54.27.8.23,1.56-.24,3.12-.53,4.78-.82l1.52,8.6c-1.63.29-3.21.56-4.78.87-.26.05-.64.29-.68.5-.31,1.82-.56,3.65-.85,5.58l4.62,2.68-4.37,7.57-4.65-2.67c-1.5,1.2-2.95,2.34-4.38,3.53a.83.83,0,0,0-.13.74c.52,1.55,1.09,3.08,1.67,4.68l-8.21,3c-.51-1.39-1.06-2.75-1.49-4.15a1.19,1.19,0,0,0-1.5-1,31.73,31.73,0,0,1-4.25,0,.71.71,0,0,0-.87.58c-.52,1.5-1.08,3-1.66,4.56l-8.22-3,1.84-5.08-4.63-3.9-4.69,2.7-4.38-7.57c1.45-.84,2.81-1.64,4.19-2.41a.76.76,0,0,0,.43-1c-.32-1.41-.58-2.84-.76-4.27-.09-.7-.25-1-1-1.13-1.52-.17-3-.5-4.52-.77Zm26.76-10.43a11.17,11.17,0,1,0,11,11.36A11.23,11.23,0,0,0,367.37,290.28Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M416.09,326,418,332c-1.11.37-2.18.69-3.21,1.08a.91.91,0,0,0-.51.65c-.09,1.06-.06,2.12-.14,3.18a.7.7,0,0,0,.53.85c1,.37,2,.81,3.08,1.25-.8,2-1.56,3.85-2.35,5.79-1.09-.44-2.12-.89-3.17-1.26a.91.91,0,0,0-.8.18c-.84.89-1.63,1.84-2.51,2.85l1.79,3.42-5.52,2.94c-.55-1-1.05-2-1.6-3a.88.88,0,0,0-.66-.4c-1.27.15-2.54.38-3.85.58l-.83,3.77-6.1-1.31.79-3.77c-1.13-.74-2.21-1.47-3.32-2.15a.79.79,0,0,0-.7.12c-.9.66-1.77,1.36-2.71,2.09l-3.85-4.93c.92-.72,1.76-1.4,2.63-2.05a.67.67,0,0,0,.3-.94,27.5,27.5,0,0,1-1-2.95.68.68,0,0,0-.78-.62c-1.09,0-2.17,0-3.16,0v-6.3h3.94c.5-1.18,1-2.36,1.51-3.57.07-.18-.12-.55-.29-.72-.78-.76-1.61-1.47-2.47-2.25l4.18-4.65,2.88,2.57c1.22-.62,2.41-1.2,3.58-1.84.14-.08.2-.46.18-.68-.12-1.08-.29-2.16-.45-3.33l6.19-.86c.16,1.11.32,2.13.43,3.16.06.58.3.82.91.89a19.56,19.56,0,0,1,2.71.59.77.77,0,0,0,1.06-.39c.53-.93,1.12-1.81,1.74-2.79l5.29,3.32-2,3.27c.79,1.07,1.56,2.13,2.37,3.14a1,1,0,0,0,.77.12C413.94,326.74,415,326.39,416.09,326Zm-16.8,16.75a8,8,0,1,0-8.12-7.84A8,8,0,0,0,399.29,342.78Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M417.48,292.14l2.41-1.89,3.06,3.87c-.59.47-1.11,1-1.7,1.34s-.81.81-.41,1.46a2.94,2.94,0,0,1,.3.76c.52,1.58.52,1.58,2.22,1.65.41,0,.82,0,1.21,0v4.89c-.92,0-1.74,0-2.55,0-.47,0-.7.11-.8.57a6.05,6.05,0,0,1-.36,1.09c-.62,1.55-.63,1.55.65,2.68l1,.87-3.28,3.69-2.3-2c-.9.47-1.8.91-2.67,1.41a.82.82,0,0,0-.25.65c.08.84.22,1.67.34,2.58l-4.87.71c-.13-.89-.23-1.73-.41-2.54a.93.93,0,0,0-.56-.6c-.9-.23-1.81-.38-2.82-.58l-1.63,2.6-4.19-2.59c.45-.74.86-1.45,1.31-2.13a.63.63,0,0,0-.08-1,8.61,8.61,0,0,1-.95-1.13c-.77-1.07-.76-1.07-2.05-.65-.51.18-1,.34-1.66.54l-1.55-4.67c.81-.27,1.56-.55,2.34-.77a.72.72,0,0,0,.61-.87,13.67,13.67,0,0,1,.08-2.12.69.69,0,0,0-.53-.85c-.77-.27-1.52-.59-2.33-.92l1.82-4.58c.84.33,1.62.67,2.42.93a.87.87,0,0,0,.75-.16c.66-.69,1.26-1.43,1.93-2.2l-1.42-2.7,4.33-2.34,1.48,2.69,3.36-.5.64-3,4.82,1c-.17.84-.32,1.63-.5,2.42a.73.73,0,0,0,.43,1C415.91,291.13,416.66,291.64,417.48,292.14Zm-14,9.24a6.28,6.28,0,1,0,6.39-6.26A6.22,6.22,0,0,0,403.49,301.38Z",
    transform: "translate(-2.56 -50.04)",
    fill: "#68e1fd",
    className: "target-color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingMonochromaticFebff);
export default __webpack_public_path__ + "static/media/coding-monochromatic-febff.eb103fe1602385eeb05c19a6478b45f5.svg";
export { ForwardRef as ReactComponent };